import React, { useEffect } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { DOM_ID } from '@UILayer/UILayer.types';

// REDUX
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';

// CSS
import styles from '@UILayer/UILayer.scss';

//INPUTS
import { Button } from '@UILayer/Inputs/Button';
import { IPreloaderState } from '@Core/PreloaderScene/PreloaderScene.types';

const IntroMovieActions: React.FC<{ gameStore: IPreloaderState }> = ({ gameStore }) => {
    const { t } = useTranslation();

    function playIntroMovie() {
        EventsCenter.emit(EGameEvents.PRELOADER_INTRO_MOVIE_PLAY);
    }

    function skipIntroMovie() {
        EventsCenter.emit(EGameEvents.PRELOADER_INTRO_MOVIE_SKIP);
    }

    return (
        <>
            {gameStore.availableActions?.play && (
                <Button
                    id={DOM_ID.BUTTON_MOVIE_PLAY}
                    description={t('WCA_PLAY_INTRODUCTION_MOVIE')}
                    className={cn(styles.prealoder_button_circle, styles.preloader_button_play)}
                    onChange={playIntroMovie}
                />
            )}
            {gameStore.availableActions?.skip && (
                <Button
                    id={DOM_ID.BUTTON_MOVIE_SKIP}
                    description={t('WCA_SKIP_INTRODUCTION_MOVIE')}
                    className={cn(styles.prealoder_button_circle, styles.preloader_button_skip)}
                    onChange={skipIntroMovie}
                />
            )}
        </>
    );
};

export default IntroMovieActions;
